export enum EContract {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  YES = "YES",
  NO = "NO",
}

export interface IStateContract {
  welcomeCallRequired: EContract | null;
  attempts: number;
  //alert: string;
  hasReceivedWelcomeCall: EContract;
  isFraud: EContract;
  contractVerballyAccepted: EContract;
}
